import {Component, OnInit} from '@angular/core';
import {DeleteButtonComponent} from "../../../core/delete-button/delete-button.component";
import {ManageButtonComponent} from "../../../core/manage-button/manage-button.component";
import {PreviewButtonComponent} from "../../../core/preview-button/preview-button.component";
import {QuickDashboardComponent} from "../../../core/quick-dashboard/quick-dashboard.component";
import {Observable} from "rxjs";
import {ApiService, RagTemplateDef, TenantListItem} from "../../../services/api.service";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-tenants-list',
  standalone: true,
  imports: [
    DeleteButtonComponent,
    ManageButtonComponent,
    PreviewButtonComponent,
    QuickDashboardComponent,
    NgIf
  ],
  templateUrl: './tenants-list.component.html'
})
export class TenantsListComponent implements OnInit {

  readonly now = new Date()
  loader?: Observable<TenantListItem[]>

  constructor(
    readonly api: ApiService,
  ) {}

  ngOnInit(): void {
    this.loader = this.api.getTenants()
  }
}
